import { useAtomValue } from 'jotai';
import FavoriteButton, { FavoriteButtonVariant } from '../common/components/FavoriteButton';
import { canAccessWishlistAtom } from './state';
import useWishlistSupplier from './useWishlistSupplier';

interface WishlistSupplierButtonProps {
  supplierId: string;
  variant?: FavoriteButtonVariant;
}

export default function WishlistSupplierButton({
  supplierId,
  variant,
}: WishlistSupplierButtonProps): React.JSX.Element | null {
  const canAccessWishlist = useAtomValue(canAccessWishlistAtom);
  const { isInWishlist, isLoading, toggleFavorite } = useWishlistSupplier(supplierId);

  if (!canAccessWishlist) {
    return null;
  }

  return (
    <FavoriteButton
      isActive={isInWishlist}
      disabled={isLoading}
      onClick={() => toggleFavorite()}
      variant={variant}
    />
  );
}
